<script setup lang="ts">
import {computed, ref} from 'vue'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

interface Props {
  forceOpen: boolean
  linkClasses: string | string[] | object
  title: string
}

const props = defineProps<Props>()
const isNewUiEnabled = useNewUiEnabled()

const state = ref(false)
const isExpanded = computed(() => props.forceOpen || !!state.value)

const iconClasses = computed(() => ({
  'fa-solid fa-angle-down text-[80%] transition-all ease-in-out': true,
  'duration-200': isNewUiEnabled.value,
  'duration-700': !isNewUiEnabled.value,
  'rotate-0': props.forceOpen || !isExpanded.value,
  'rotate-180': !props.forceOpen && isExpanded.value,
}))

function onClick() {
  if (props.forceOpen) return
  state.value = !state.value
}
</script>

<template>
  <a class="whitespace-nowrap" :class="linkClasses" @click="onClick">
    <i v-if="!isNewUiEnabled" :class="iconClasses"></i>
    {{ title }}
    <i v-if="isNewUiEnabled" class="ml-1" :class="iconClasses"></i>
  </a>

  <transition name="expand">
    <div v-if="isExpanded" class="bg-inherit">
      <slot></slot>
    </div>
  </transition>
</template>
